import { get, head } from 'lodash'

export const getData = obj => get(obj, 'data')
export const getData2 = obj => {
  return get(obj, 'body')
}

/**
 * Output integers with leading zeros
 */
export const pad = (num, size) => {
  let s = num + ''
  while (s.length < size) s = '0' + s
  return s
}

// http://dense13.com/blog/2009/05/03/converting-string-to-slug-javascript/
export const stringToSlug = (str) => {
  if (str !== undefined) {
    str = str.toLowerCase()
    str = str.replace(/^\s+|\s+$/g, '') // trim

    // remove accents, swap ñ for n, etc
    let from = 'ãàáâèéëêìíïîòóöôùúüûñç·/_,:;'
    let to = 'aaaaeeeeiiiioooouuuunc------'

    for (let i = 0, l = from.length; i < l; i++) {
      str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
      .replace(/\s+/g, '-') // collapse whitespace and replace by -
      .replace(/-+/g, '-') // collapse dashes

    return str
  }
}
export const makeErrorFilds = (err) => {
  let errorI = {}
  let x
  for (x in err.body) {
    errorI[err.body[x].field] = err.body[x].messages[0]
  }
  return errorI
}
export const getErrorFilds = (err) => {
  let errorI = {}
  let x
  for (x in err.body.data) {
    errorI[x] = head(err.body.data[x])
  }
  return errorI
}

export const getError = (err) => {
  let errorInput = err.body.error.errors
  let errorI = {}
  let x
  for (x in errorInput) {
    errorI[x] = head(errorInput[x])
  }
  let error = {
    'errors': errorI,
    'message': err.body.message
  }
  return error
}

export const getLocalization = () => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function (e) {
      let date = {
        lat: e.coords.latitude,
        lng: e.coords.longitude
      }
      
      return date
    })
  }
}
// https://stackoverflow.com/questions/33023868/convert-string-representing-a-number-of-any-base-to-number
export const stringToNumber = (str) => {
  return str.toLowerCase().match(/\d+/)
}

export const searchCNPJ = (cnpj) => {
  window.$.ajax({
    url: 'https://www.receitaws.com.br/v1/cnpj/' + cnpj,
    dataType: 'jsonp',
    type: 'GET',
    success: function (data) {
      return data
    },
    error: function (request, error) {
      return error
    }
  })
}

export const validateCPF = (cpf) => {
  
  if (!cpf || typeof cpf !== 'string') {
    return false;
  }

  // Remove caracteres não numéricos
  cpf = cpf.replace(/[^\d]/g, '');

  // Verifica se o CPF tem 11 dígitos
  if (cpf.length !== 11) {
    return false;
  }

  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1+$/.test(cpf)) {
    return false;
  }

  // Calcula o primeiro dígito verificador
  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpf.charAt(i)) * (10 - i);
  }
  let resto = 11 - (soma % 11);
  let digito1 = (resto === 10 || resto === 11) ? 0 : resto;

  // Calcula o segundo dígito verificador
  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpf.charAt(i)) * (11 - i);
  }
  resto = 11 - (soma % 11);
  let digito2 = (resto === 10 || resto === 11) ? 0 : resto;

  // Verifica se os dígitos verificadores estão corretos
  return (digito1 === parseInt(cpf.charAt(9)) && digito2 === parseInt(cpf.charAt(10)));
}

export const validateEmail = (email) => {
  const regex = /^[a-zA-Z0-9]+([._-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
  return regex.test(email);
}

export const validateCNPJ = (cnpj) => {

  if (!cnpj || typeof cnpj !== 'string') {
    return false;
  }

  // Remove caracteres não numéricos
  cnpj = cnpj.replace(/[^\d]/g, '');

  // Verifica se o CNPJ tem 14 dígitos
  if (cnpj.length !== 14) {
    return false;
  }

  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1+$/.test(cnpj)) {
    return false;
  }

  // Calcula o primeiro dígito verificador
  let soma = 0;
  let peso = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  for (let i = 0; i < 12; i++) {
    soma += parseInt(cnpj.charAt(i)) * peso[i];
  }
  let resto = soma % 11;
  let digito1 = (resto < 2) ? 0 : 11 - resto;

  // Calcula o segundo dígito verificador
  soma = 0;
  peso = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  for (let i = 0; i < 13; i++) {
    soma += parseInt(cnpj.charAt(i)) * peso[i];
  }
  resto = soma % 11;
  let digito2 = (resto < 2) ? 0 : 11 - resto;

  // Verifica se os dígitos verificadores estão corretos
  return (digito1 === parseInt(cnpj.charAt(12)) && digito2 === parseInt(cnpj.charAt(13)));
}

export const getJsonp = (url, callback) => {
  const script = document.createElement('script')
  const callbackName =
    'jsonp_callback_' + Math.round(100000 * Math.random())
  window[callbackName] = function (data) {
    delete window[callbackName]
    document.body.removeChild(script)
    callback(data)
  }
  script.src = url + (url.includes('?') ? '&' : '?') + 'callback=' + callbackName
  document.body.appendChild(script)
}

export const minInDayHouMin = (val) => {
  // let m1 = parseFloat(stripBad(val))
  let m1 = parseFloat(val)
  if (isNaN(m1)) m1 = 0
  var t3 = m1
  var t4 = Math.floor(t3 / 1440)
  var t5 = t3 - (t4 * 1440)
  var t6 = Math.floor(t5 / 60)
  var t7 = t5 - (t6 * 60)
  return '  ' + t4 + 'd ' + t6 + 'h ' + t7 + 'm'
}

export const setFormData = (obj) => {
  const formData = new FormData();
  Object.keys(obj).forEach(key => formData.append(key, obj[key]));
  return formData;
}
export const FILTER_COCRE = () => { return 'FILTER_COCRE' }

export const clearRuleForm = (ruleform) => {
  const rf = {}
  Object.keys(ruleform).forEach(key => {
    if (ruleform[key] !== '' && ruleform[key] !== null && key !== 'created_at' && key !== 'deleted_at' && key !== 'updated_at') {
      rf[key] = ruleform[key]
    }
  })
  return rf
}

export const cloneObj = (obj) => {
  var copy;
  // Handle the 3 simple types, and null or undefined
  if (null == obj || "object" != typeof obj) return obj;

  // Handle Date
  if (obj instanceof Date) {
    copy = new Date();
    copy.setTime(obj.getTime());
    return copy;
  }

  // Handle Array
  if (obj instanceof Array) {
    copy = [];
    for (var i = 0, len = obj.length; i < len; i++) {
      copy[i] = cloneObj(obj[i]);
    }
    return copy;
  }

  // Handle Object
  if (obj instanceof Object) {
    copy = {};
    for (var attr in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(attr)) copy[attr] = cloneObj(obj[attr]);
    }
    return copy;
  }

  throw new Error("Unable to copy obj! Its type isn't supported.");
}

export const toSlug = (string, slice = 9999999) => {
  const from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;"
  const to = "aaaaaeeeeeiiiiooooouuuunc------"

  const newText = string.split('').map(
    (letter, i) => letter.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i)))

  return newText
    .toString()
    .normalize('NFD')                   // split an accented letter in the base letter and the acent
    .replace(/[\u0300-\u036f]/g, '')   // remove all previously split accents
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9 ]/g, '')   // remove all chars not letters, numbers and spaces (to be replaced)
    .replace(/\s+/g, '-')
    .slice(0, slice);
}

export const getStatusLabel = (status) => {
  switch (status) {
    case 'succeeded':
      return 'Concluído';
    case 'risk_analysis_approved':
      return 'Analise de Risco Aprovada';
    case 'active':
    case 'ativo':
      return 'Ativo';
    case 'approved':
      return 'Aprovado';
    case 'homologated':
      return 'Homologado';
    case 'new':
      return 'Novo';
    case 'pending':
      return 'Pendente';
    case 'pendingSend':
      return 'Envio Pendente';
    case 'risk_analysis_manually':
      return 'Analise Manual';
    case 'risk':
      return 'Risco';
    case 'inactive':
    case 'inativo':
      return 'Inativo';
    case 'readyToCancel':
      return 'Aguardando Cancelamento';
    case 'canceled':
      return 'Cancelado';
    case 'undone':
    case 'refunded':
      return 'Estorno';
    case 'refused':
      return 'Recusou';
    case 'risk_analysis_reproved':
    case 'risk_analysis_rejected':
      return 'Analise de Risco Reprovada';
    case 'in_progress':
      return 'Em andamento';
    case 'risk_analysis':
      return 'Em Analise de Risco';
    case 'risk_analysis_error':
      return 'Erro na Analise de Risco';
    case 'risk_analysis_awaiting':
      return 'Aguardando Documentação';
    case 'paused':
      return 'Pausada';
    case 'error':
      return 'Erro';
    case 'waiting_amount':
      return 'Aguardando Saldo';
    case 'partial_discount':
      return 'Descontado Parcial';
    case 'expired':
      return 'Expirado';
    case '0':
      return 'Não';
    case '1':
      return 'Sim';
    default:
      return 'Status Desconhecido';
  }
};
